import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AddEditOrderPartyComponent } from 'src/app/inventory/dialogs/add-edit-order-party/add-edit-order-party.component';
import { AutocompleteModule } from 'src/app/shared/autocomplete/autocomplete.module';
import { ButtonModule } from 'src/app/shared/components/button/button.module';
import { CheckboxModule } from 'src/app/shared/components/checkbox/checkbox.module';
import { DialogModule } from 'src/app/shared/components/dialog/dialog.module';
import { DropdownWithOverlayOptionsListModule } from 'src/app/shared/components/dropdown-with-overlay-options-list/dropdown-with-overlay-options-list.module';
import { InputModule } from 'src/app/shared/components/input/input.module';
import { ThreeDotsMenuModule } from 'src/app/shared/components/three-dots-menu/three-dots-menu.module';
import { SupplierBuyerCardComponent } from './supplier-buyer-card.component';



@NgModule({
  declarations: [SupplierBuyerCardComponent, AddEditOrderPartyComponent],
  imports: [
    CommonModule,
    ThreeDotsMenuModule,
    AutocompleteModule,
    FormsModule,
    ReactiveFormsModule,
    DialogModule,
    CheckboxModule,
    ButtonModule,
    InputModule,
    DropdownWithOverlayOptionsListModule
  ],
  exports: [SupplierBuyerCardComponent]
})
export class SupplierBuyerCardModule { }
